import type { ReactNode } from 'react';

interface PageHeaderProps {
  /** Der Seitentitel. Ein String ist der Regelfall; ein Knoten erlaubt
   *  Schilder oder Zaehler direkt neben dem Titel. */
  title: ReactNode;
  subtitle?: string;
  /** Der Weg zur Seite, von der Wurzel her. Das letzte Glied ist die Seite selbst. */
  breadcrumb?: readonly string[];
  /** Die eine Hauptaktion des Bereichs. Nur eine -- mehr ist keine Hauptaktion. */
  action?: ReactNode;
  /** Eine Zahl oder Kennung neben dem Titel -- etwa die Ladestandzeile einer Liste. */
  count?: ReactNode;
  /** Beschriftung der Brotkrumen fuer vorlesende Programme. */
  breadcrumbLabel?: string;
}

/** Seitenkopf: Titel, Untertitel, Brotkrumen und die eine Hauptaktion. */
export function PageHeader({
  title,
  subtitle,
  breadcrumb,
  action,
  count,
  breadcrumbLabel = 'Pfad',
}: PageHeaderProps) {
  return (
    <header className="page-head">
      <div>
        {breadcrumb && breadcrumb.length > 0 ? (
          <nav className="page-head__breadcrumb" aria-label={breadcrumbLabel}>
            <ol>
              {breadcrumb.map((part, index) => (
                <li key={`${String(index)}-${part}`}>{part}</li>
              ))}
            </ol>
          </nav>
        ) : null}
        <div className="page-head__title-wrap">
          <h1 className="page-head__title">{title}</h1>
          {count ? <span className="page-head__count">{count}</span> : null}
        </div>
        {subtitle ? <p className="page-head__subtitle">{subtitle}</p> : null}
      </div>
      {action ? <div className="page-head__action">{action}</div> : null}
    </header>
  );
}
